/*
 ***************************************************
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2022
 *
 ***************************************************
 */

import styled from "@mui/styled-engine-sc";

// Base styled SVG component
const StyledNavIcon = styled("svg")<{ $isActive?: boolean }>`
  ${({ theme, $isActive }) => `
    width: 24px;
    height: 24px;
    flex-shrink: 0;
    display: block;

    path {
      fill: ${$isActive ? theme.palette.primary.main : theme.palette.gray.neutralGray800};
      transition: fill 0.2s ease;
    }
  `}
`;

// Porte (Door/Window) Icon
export const PorteIcon = styled(({ $isActive, ...props }: any) => (
  <StyledNavIcon
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    $isActive={$isActive}
    {...props}>
    <path d="M12 2C16.4183 2 20 5.58172 20 10V20C20 21.1046 19.1046 22 18 22H6C4.89543 22 4 21.1046 4 20V10C4 5.58172 7.58172 2 12 2ZM6 13V20H11V13H6ZM13 13V20H18V13H13ZM11 4.08398C8.16237 4.56013 6 7.02706 6 10V11H11V4.08398ZM13 11H18V10C18 7.02706 15.8376 4.56013 13 4.08398V11Z" />
  </StyledNavIcon>
))``;

// Salle de bains & WC (Bathroom) Icon
export const SalleDeBainsIcon = styled(({ $isActive, ...props }: any) => (
  <StyledNavIcon
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    $isActive={$isActive}
    {...props}>
    <path d="M15 0C16.6569 0 18 1.34315 18 3V11C19.1046 11 20 11.8954 20 13V16C20 18.2091 18.2091 20 16 20H4C1.85996 20 0.11211 18.3194 0.00487995 16.2061L0 16V13C0 12.0683 0.63768 11.2877 1.5 11.0654C2 11 2.39543 11 3.5 11H3.62988C4.10729 11 4.5 11 4.93164 11H7.86914H16V3C16 2.44772 15.5523 2 15 2H14.8281C14.563 2.00008 14.3086 2.1055 14.1211 2.29297L13.4141 3L13.457 3.04297C13.8476 3.43349 13.8476 4.06651 13.457 4.45703C13.0665 4.84756 12.4335 4.84756 12.043 4.45703L10.543 2.95703C10.1524 2.56651 10.1524 1.93349 10.543 1.54297C10.9335 1.15244 11.5665 1.15244 11.957 1.54297L12 1.58594L12.707 0.87891C13.2696 0.31637 14.0326 8e-05 14.8281 0H15ZM2 16L2.01074 16.2041C2.113 17.2128 2.96435 18 4 18H16C17.1046 18 18 17.1046 18 16V13H2V16Z" />
  </StyledNavIcon>
))``;

// Cuisine (Kitchen) Icon
export const CuisineIcon = styled(({ $isActive, ...props }: any) => (
  <StyledNavIcon
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="18"
    viewBox="0 0 20 18"
    fill="none"
    $isActive={$isActive}
    {...props}>
    <path d="M12 0C12.5523 0 13 0.44772 13 1V2H19C19.5523 2 20 2.44772 20 3C20 3.55228 19.5523 4 19 4H18V15C18 16.6569 16.6569 18 15 18H5C3.39489 18 2.08421 16.7394 2.00391 15.1543L2 15V4H1C0.44772 4 0 3.55228 0 3C0 2.44772 0.44772 2 1 2H7V1C7 0.44772 7.44772 0 8 0H12ZM4 15L4.00488 15.1025C4.05621 15.6067 4.48232 16 5 16H15C15.5523 16 16 15.5523 16 15V4H4V15Z" />
  </StyledNavIcon>
))``;

// Aménagement (Layout/Dressing) Icon
export const AmenagementIcon = styled(({ $isActive, ...props }: any) => (
  <StyledNavIcon
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="15"
    viewBox="0 0 20 15"
    fill="none"
    $isActive={$isActive}
    {...props}>
    <path d="M10 0C11.6569 0 13 1.34315 13 3C13 4.30574 12.1645 5.413 11 5.8252V6.4111L18.9717 10.8398C19.6065 11.1926 20 11.8626 20 12.5889V13C20 14.1046 19.1046 15 18 15H2C0.89543 15 0 14.1046 0 13V12.5889C0 11.8626 0.39351 11.1926 1.02832 10.8398L9 6.4111V5C9 4.48233 9.3933 4.05622 9.8975 4.00488L10.1025 3.99512C10.6067 3.94379 11 3.51768 11 3C11 2.44772 10.5523 2 10 2C9.6311 2.00001 9.3072 2.19947 9.1328 2.50098C8.8562 2.97877 8.2445 3.14171 7.7666 2.86523C7.28881 2.5886 7.12587 1.97697 7.40234 1.49902C7.9196 0.60513 8.8885 0 10 0ZM2 12.5889V13H18V12.5889L10 8.1436L2 12.5889Z" />
  </StyledNavIcon>
))``;

// Escalier (Stairs) Icon
export const EscalierIcon = styled(({ $isActive, ...props }: any) => (
  <StyledNavIcon
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    $isActive={$isActive}
    {...props}>
    <path d="M20 0C20.5523 0 21 0.44772 21 1V20C21 20.5523 20.5523 21 20 21H1C0.44772 21 0 20.5523 0 20V17C0 15.8954 0.89543 15 2 15H5V12C5 10.8954 5.89543 10 7 10H10V7C10 5.89543 10.8954 5 12 5H15V2C15 0.89543 15.8954 0 17 0H20ZM17 6C17 6.55228 16.5523 7 16 7H12V11C12 11.5523 11.5523 12 11 12H7V16C7 16.5523 6.55228 17 6 17H2V19H19V2H17V6Z" />
  </StyledNavIcon>
))``;

// Portail (Gate/Fence) Icon
export const PortailIcon = styled(({ $isActive, ...props }: any) => (
  <StyledNavIcon
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="18"
    viewBox="0 0 20 18"
    fill="none"
    $isActive={$isActive}
    {...props}>
    <path d="M15.4316 0.177681C15.7977 -0.0757288 16.293 -0.0582988 16.6406 0.231391L19.6406 2.73139C19.8685 2.92138 20 3.20322 20 3.49994V16C20 17.1045 19.1045 18 18 18H2C0.89545 18 3e-05 17.1045 0 16V3.49994L0.00586009 3.38959C0.0341801 3.13432 0.15993 2.89765 0.35938 2.73139L3.35938 0.231391L3.43164 0.177681C3.79773 -0.0757288 4.293 -0.0582988 4.64062 0.231391L7 2.19721L9.3594 0.231391L9.4316 0.177681C9.7977 -0.0757288 10.293 -0.0582988 10.6406 0.231391L13 2.19721L15.3594 0.231391L15.4316 0.177681ZM2 3.96869V16H6V3.96869L4 2.3017L2 3.96869ZM8 3.96869V16H12V3.96869L10 2.3017L8 3.96869ZM14 3.96869V16H18V3.96869L16 2.3017L14 3.96869Z" />
  </StyledNavIcon>
))``;

// Revêtement (Floor/Wall Covering) Icon
export const RevetementIcon = styled(({ $isActive, ...props }: any) => (
  <StyledNavIcon
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    $isActive={$isActive}
    {...props}>
    <path d="M16 0C17.1046 0 18 0.89543 18 2V16C18 17.1046 17.1046 18 16 18H2C0.89543 18 0 17.1046 0 16V2C0 0.89543 0.89543 0 2 0H16ZM2 8.4141V9.5859L8.4141 16H9.5859L16 9.5859V8.4141L9.5859 2H8.4141L2 8.4141ZM12.4141 16H16V12.4141L12.4141 16ZM2 16H5.58594L2 12.4141V16ZM2 5.58594L5.58594 2H2V5.58594ZM16 5.58594V2H12.4141L16 5.58594Z" />
  </StyledNavIcon>
))``;

// Equipment (Equipment/Tool) Icon
export const EquipmentIcon = styled(({ $isActive, ...props }: any) => (
  <StyledNavIcon
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    $isActive={$isActive}
    {...props}>
    <path d="M13 0C13.5523 0 14 0.44772 14 1H15.5C16.6046 1 17.5 1.89543 17.5 3V4H19.5C20.0523 4 20.5 4.44772 20.5 5C20.5 5.55228 20.0523 6 19.5 6H17.5V7C17.5 8.1046 16.6046 9 15.5 9H14C14 9.5523 13.5523 10 13 10H10V14C11.1046 14 12 14.8954 12 16V18C12 19.1046 11.1046 20 10 20H4C2.89543 20 2 19.1046 2 18V16C2 14.8954 2.89543 14 4 14V10H3C1.34315 10 0 8.6569 0 7V3C0 1.34315 1.34315 0 3 0H13ZM4 18H10V16H4V18ZM3 2C2.44772 2 2 2.44772 2 3V7C2 7.55228 2.44772 8 3 8H5C5.55228 8 6 8.4477 6 9V14H8V9C8 8.4477 8.4477 8 9 8H12V2H3ZM14 7H15.5V3H14V7ZM9 4C9.5523 4 10 4.44772 10 5C10 5.55228 9.5523 6 9 6H5C4.44772 6 4 5.55228 4 5C4 4.44772 4.44772 4 5 4H9Z" />
  </StyledNavIcon>
))``;

// Discount/Sale Tag Icon (for "Voir les bonnes affaires")
export const DiscountTagIcon = styled((props: any) => (
  <StyledNavIcon xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M10.5862 2.00026C11.3672 1.21932 12.6332 1.21932 13.4143 2.00026L15.4143 4.00026H18.0002C19.1047 4.00039 20.0002 4.89577 20.0002 6.00026V8.5862L22.0002 10.5862C22.7809 11.3672 22.7811 12.6334 22.0002 13.4143L20.0002 15.4143V18.0002C20.0001 19.1046 19.1046 20.0001 18.0002 20.0002H15.4143L13.4143 22.0002C12.6333 22.7811 11.3672 22.781 10.5862 22.0002L8.5862 20.0002H6.00026C4.89577 20.0002 4.00039 19.1047 4.00026 18.0002V15.4143L2.00026 13.4143C1.21932 12.6333 1.21932 11.3672 2.00026 10.5862L4.00026 8.5862V6.00026C4.00026 4.89569 4.89569 4.00026 6.00026 4.00026H8.5862L10.5862 2.00026ZM9.70729 5.7073C9.51981 5.89478 9.2654 6.0002 9.00026 6.00026H6.00026V9.00026C6.0002 9.2654 5.89478 9.5198 5.70729 9.7073L3.41433 12.0002L5.70729 14.2932C5.89469 14.4807 6.00026 14.7351 6.00026 15.0002V18.0002H9.00026C9.2654 18.0003 9.51981 18.1057 9.70729 18.2932L12.0002 20.5862L14.2932 18.2932L14.3664 18.2268C14.5444 18.081 14.7681 18.0002 15.0002 18.0002H18.0002V15.0002C18.0002 14.735 18.1056 14.4807 18.2932 14.2932L20.5862 12.0002L18.2932 9.7073C18.1057 9.5198 18.0003 9.2654 18.0002 9.00026V6.00026H15.0002C14.7351 6.00026 14.4807 5.89469 14.2932 5.7073L12.0002 3.41433L9.70729 5.7073ZM14.5002 13.0002C15.3285 13.0004 16.0002 13.6719 16.0002 14.5002C16.0001 15.3285 15.3285 16.0001 14.5002 16.0002C13.6719 16.0002 13.0003 15.3286 13.0002 14.5002C13.0002 13.6718 13.6718 13.0002 14.5002 13.0002ZM13.7932 8.79323C14.1837 8.40271 14.8167 8.40271 15.2072 8.79323C15.5975 9.18378 15.5977 9.81685 15.2072 10.2073L10.2072 15.2073C9.81685 15.5977 9.18377 15.5976 8.79323 15.2073C8.40271 14.8168 8.40271 14.1837 8.79323 13.7932L13.7932 8.79323ZM9.50026 8.00026C10.3285 8.00039 11.0002 8.67191 11.0002 9.50026C11.0001 10.3285 10.3285 11.0001 9.50026 11.0002C8.67191 11.0002 8.00039 10.3286 8.00026 9.50026C8.00026 8.67184 8.67184 8.00026 9.50026 8.00026Z"
      fill="#C41E3B"
    />
  </StyledNavIcon>
))`
  ${({ theme }) => `
    path {
      fill: ${theme.palette.primary.main};
    }
  `}
`;

// Produits (Products) Icon - Cube/3D icon
export const ProduitsIcon = styled(({ $isActive, ...props }: any) => (
  <StyledNavIcon
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="20"
    viewBox="0 0 18 20"
    fill="none"
    $isActive={$isActive}
    {...props}>
    <path d="M8.0195 0.256845C8.6284 -0.085615 9.3716 -0.085615 9.9805 0.256845L16.9805 4.19435C17.6102 4.54858 18 5.21497 18 5.93751V13.7675C18 14.4901 17.6102 15.1565 16.9805 15.5107L9.9805 19.4482C9.3716 19.7907 8.6284 19.7907 8.0195 19.4482L1.01953 15.5107C0.38978 15.1565 0 14.4901 0 13.7675V5.93751C0 5.21497 0.38978 4.54858 1.01953 4.19435L8.0195 0.256845ZM2 13.7675L8 17.1425V10.4365L2 7.06152V13.7675ZM10 10.4365V17.1425L16 13.7675V7.06152L10 10.4365ZM3.03906 5.35255L9 8.70504L14.96 5.35255L9 2.00001L3.03906 5.35255Z" />
  </StyledNavIcon>
))``;

// Inspiration & Conseil (Inspiration & Advice) Icon - House/Building icon
export const InspirationConseilIcon = styled(({ $isActive, ...props }: any) => (
  <StyledNavIcon
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="20"
    viewBox="0 0 15 20"
    fill="none"
    $isActive={$isActive}
    {...props}>
    <path d="M7.5 0C11.6421 0 15 3.35786 15 7.5C15 9.9537 13.8178 12.1265 12 13.4932V16.5C12 17.6046 11.1046 18.5 10 18.5H9.4346C9.2123 19.3623 8.4317 20 7.5 20C6.5683 20 5.7877 19.3623 5.5654 18.5H5C3.89543 18.5 3 17.6046 3 16.5V13.4932C1.18218 12.1265 0 9.9537 0 7.5C0 3.35786 3.35786 0 7.5 0ZM5 16.5H10V14H5V16.5ZM7.5 2C4.46243 2 2 4.46243 2 7.5C2 9.3601 2.92469 11.0033 4.34277 12H6.5V9.5H6C5.44772 9.5 5 9.0523 5 8.5C5 7.94772 5.44772 7.5 6 7.5H9C9.5523 7.5 10 7.94772 10 8.5C10 9.0523 9.5523 9.5 9 9.5H8.5V12H10.6572C12.0753 11.0033 13 9.3601 13 7.5C13 4.46243 10.5376 2 7.5 2Z" />
  </StyledNavIcon>
))``;

// Outils de conception (Design Tools) Icon - Clock/Design tool icon
export const OutilsConceptionIcon = styled(({ $isActive, ...props }: any) => (
  <StyledNavIcon
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    $isActive={$isActive}
    {...props}>
    <path d="M12 2C17.5228 2 22 6.47715 22 12H20C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20V22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12.5332 13.7793C12.3044 13.0165 13.0165 12.3044 13.7793 12.5332L20.4824 14.5449C20.9501 14.6856 20.9589 15.3445 20.4951 15.498L18.2246 16.25L21.5127 19.5371C22.0581 20.0825 22.0581 20.9673 21.5127 21.5127C20.9673 22.0581 20.0825 22.0581 19.5371 21.5127L16.25 18.2246L15.498 20.4951C15.3445 20.9589 14.6856 20.9501 14.5449 20.4824L12.5332 13.7793Z" />
  </StyledNavIcon>
))``;

// Services Icon
export const ServicesIcon = styled(({ $isActive, ...props }: any) => (
  <StyledNavIcon
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    $isActive={$isActive}
    {...props}>
    <path d="M16 0C17.1046 0 18 0.89543 18 2V16C18 17.1046 17.1046 18 16 18H2C0.89543 18 0 17.1046 0 16V2C0 0.89543 0.89543 0 2 0H16ZM2 16H16V2H2V16ZM9 8C9.5523 8 10 8.4477 10 9V12H10.5C11.0523 12 11.5 12.4477 11.5 13C11.5 13.5523 11.0523 14 10.5 14H7.5C6.94772 14 6.5 13.5523 6.5 13C6.5 12.4477 6.94772 12 7.5 12H8V10H7.5C6.94772 10 6.5 9.5523 6.5 9C6.5 8.4477 6.94772 8 7.5 8H9ZM8.75 4C9.4404 4 10 4.55964 10 5.25C10 5.94036 9.4404 6.5 8.75 6.5C8.0596 6.5 7.5 5.94036 7.5 5.25C7.5 4.55964 8.0596 4 8.75 4Z" />
  </StyledNavIcon>
))``;

// Bons plans (Good Deals) Icon
export const BonsPlansIcon = styled(({ $isActive, ...props }: any) => (
  <StyledNavIcon
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    $isActive={$isActive}
    {...props}>
    <path d="M9.17169 0.585705C9.95269 -0.195235 11.2187 -0.195235 11.9998 0.585705L13.9998 2.5857H16.5857C17.6902 2.58583 18.5857 3.48121 18.5857 4.5857V7.17164L20.5857 9.17166C21.3664 9.95266 21.3666 11.2189 20.5857 11.9998L18.5857 13.9998V16.5857C18.5856 17.6901 17.6901 18.5856 16.5857 18.5857H13.9998L11.9998 20.5857C11.2188 21.3666 9.95269 21.3665 9.17169 20.5857L7.17165 18.5857H4.5857C3.48121 18.5857 2.58583 17.6902 2.5857 16.5857V13.9998L0.585705 11.9998C-0.195235 11.2188 -0.195235 9.95266 0.585705 9.17166L2.5857 7.17164V4.5857C2.5857 3.48113 3.48113 2.5857 4.5857 2.5857H7.17165L9.17169 0.585705ZM8.29274 4.29275C8.10526 4.48023 7.85084 4.58564 7.5857 4.5857H4.5857V7.58571C4.58564 7.85085 4.48023 8.10525 4.29274 8.29274L1.99977 10.5857L4.29274 12.8787C4.48013 13.0662 4.5857 13.3206 4.5857 13.5857V16.5857H7.5857C7.85084 16.5858 8.10526 16.6912 8.29274 16.8787L10.5857 19.1717L12.8787 16.8787L12.9519 16.8123C13.1299 16.6665 13.3536 16.5857 13.5857 16.5857H16.5857V13.5857C16.5857 13.3205 16.6911 13.0662 16.8787 12.8787L19.1717 10.5857L16.8787 8.29274C16.6912 8.10525 16.5858 7.85085 16.5857 7.58571V4.5857H13.5857C13.3206 4.5857 13.0662 4.48013 12.8787 4.29275L10.5857 1.99977L8.29274 4.29275ZM13.0857 11.5857C13.914 11.5859 14.5857 12.2574 14.5857 13.0857C14.5856 13.914 13.914 14.5856 13.0857 14.5857C12.2574 14.5857 11.5858 13.9141 11.5857 13.0857C11.5857 12.2573 12.2573 11.5857 13.0857 11.5857ZM12.3787 7.37867C12.7692 6.98815 13.4022 6.98815 13.7927 7.37867C14.183 7.76923 14.1832 8.4023 13.7927 8.79276L8.7927 13.7928C8.4023 14.1832 7.76922 14.1831 7.37868 13.7928C6.98816 13.4023 6.98816 12.7692 7.37868 12.3787L12.3787 7.37867ZM8.0857 6.58571C8.91399 6.58584 9.5857 7.25735 9.5857 8.0857C9.5856 8.91397 8.91399 9.58556 8.0857 9.58566C7.25735 9.58566 6.58583 8.91406 6.5857 8.0857C6.5857 7.25728 7.25728 6.58571 8.0857 6.58571Z" />
  </StyledNavIcon>
))``;

// Le club pros (Pro Club) Icon
export const LeClubProsIcon = styled(({ $isActive, ...props }: any) => (
  <StyledNavIcon
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="19"
    viewBox="0 0 20 19"
    fill="none"
    $isActive={$isActive}
    {...props}>
    <path d="M12.2041 0.0107401C13.2128 0.113 14 0.96435 14 2V4H18C19.1046 4 20 4.89543 20 6V17C20 18.1046 19.1046 19 18 19H2C0.89543 19 0 18.1046 0 17V6C0 4.89543 0.89543 4 2 4H6V2C6 0.89543 6.89543 0 8 0H12L12.2041 0.0107401ZM2 13V17H18V13H13C13 14.1046 12.1046 15 11 15H9C7.89543 15 7 14.1046 7 13H2ZM9 13H11V11H9V13ZM2 11H7C7 9.8954 7.89543 9 9 9H11C12.1046 9 13 9.8954 13 11H18V6H2V11ZM8 4H12V2H8V4Z" />
  </StyledNavIcon>
))``;

export const PromotionIcon = styled(({ $isActive, ...props }: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="#C41E3B"
    $isActive={$isActive}
    {...props}>
    <path
      d="M9.17169 0.585705C9.95269 -0.195235 11.2187 -0.195235 11.9998 0.585705L13.9998 2.5857H16.5857C17.6902 2.58583 18.5857 3.48121 18.5857 4.5857V7.17164L20.5857 9.17166C21.3664 9.95266 21.3666 11.2189 20.5857 11.9998L18.5857 13.9998V16.5857C18.5856 17.6901 17.6901 18.5856 16.5857 18.5857H13.9998L11.9998 20.5857C11.2188 21.3666 9.95269 21.3665 9.17169 20.5857L7.17165 18.5857H4.5857C3.48121 18.5857 2.58583 17.6902 2.5857 16.5857V13.9998L0.585705 11.9998C-0.195235 11.2188 -0.195235 9.95266 0.585705 9.17166L2.5857 7.17164V4.5857C2.5857 3.48113 3.48113 2.5857 4.5857 2.5857H7.17165L9.17169 0.585705ZM8.29274 4.29275C8.10526 4.48023 7.85084 4.58564 7.5857 4.5857H4.5857V7.58571C4.58564 7.85085 4.48023 8.10525 4.29274 8.29274L1.99977 10.5857L4.29274 12.8787C4.48013 13.0662 4.5857 13.3206 4.5857 13.5857V16.5857H7.5857C7.85084 16.5858 8.10526 16.6912 8.29274 16.8787L10.5857 19.1717L12.8787 16.8787L12.9519 16.8123C13.1299 16.6665 13.3536 16.5857 13.5857 16.5857H16.5857V13.5857C16.5857 13.3205 16.6911 13.0662 16.8787 12.8787L19.1717 10.5857L16.8787 8.29274C16.6912 8.10525 16.5858 7.85085 16.5857 7.58571V4.5857H13.5857C13.3206 4.5857 13.0662 4.48013 12.8787 4.29275L10.5857 1.99977L8.29274 4.29275ZM13.0857 11.5857C13.914 11.5859 14.5857 12.2574 14.5857 13.0857C14.5856 13.914 13.914 14.5856 13.0857 14.5857C12.2574 14.5857 11.5858 13.9141 11.5857 13.0857C11.5857 12.2573 12.2573 11.5857 13.0857 11.5857ZM12.3787 7.37867C12.7692 6.98815 13.4022 6.98815 13.7927 7.37867C14.183 7.76923 14.1832 8.4023 13.7927 8.79276L8.7927 13.7928C8.4023 14.1832 7.76922 14.1831 7.37868 13.7928C6.98816 13.4023 6.98816 12.7692 7.37868 12.3787L12.3787 7.37867ZM8.0857 6.58571C8.91399 6.58584 9.5857 7.25735 9.5857 8.0857C9.5856 8.91397 8.91399 9.58556 8.0857 9.58566C7.25735 9.58566 6.58583 8.91406 6.5857 8.0857C6.5857 7.25728 7.25728 6.58571 8.0857 6.58571Z"
      fill="#C41E3B"
    />
  </svg>
))``;

export const AccesProIcon = styled(({ $isActive, ...props }: any) => (
  <StyledNavIcon
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    $isActive={$isActive}
    {...props}>
    <path
      d="M14.2041 2.01074C15.2128 2.113 16 2.96435 16 4V6H20C21.1046 6 22 6.89543 22 8V19C22 20.1046 21.1046 21 20 21H4C2.89543 21 2 20.1046 2 19V8C2 6.89543 2.89543 6 4 6H8V4C8 2.89543 8.89543 2 10 2H14L14.2041 2.01074ZM4 15V19H20V15H15C15 16.1046 14.1046 17 13 17H11C9.89543 17 9 16.1046 9 15H4ZM11 15H13V13H11V15ZM4 13H9C9 11.8954 9.89543 11 11 11H13C14.1046 11 15 11.8954 15 13H20V8H4V13ZM10 6H14V4H10V6Z"
      fill="black"
    />
  </StyledNavIcon>
))``;

export const LocationIcon = styled(({ $isActive, ...props }: any) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="white"
    xmlns="http://www.w3.org/2000/svg"
    $isActive={$isActive}
    {...props}>
    <path
      d="M12 2C16.4183 2 20 5.58172 20 10C20 12.162 18.8982 14.2875 17.6562 16.0215C16.3959 17.7811 14.8867 19.2812 13.8623 20.2158C12.7992 21.1858 11.2008 21.1858 10.1377 20.2158C9.11332 19.2812 7.60409 17.7811 6.34375 16.0215C5.10183 14.2875 4 12.162 4 10C4 5.58172 7.58172 2 12 2ZM12 4C8.68629 4 6 6.68629 6 10C6 11.529 6.80498 13.2313 7.96973 14.8574C9.11604 16.4578 10.5135 17.8507 11.4863 18.7383C11.7858 19.0114 12.2142 19.0114 12.5137 18.7383C13.4865 17.8507 14.884 16.4578 16.0303 14.8574C17.195 13.2313 18 11.529 18 10C18 6.68629 15.3137 4 12 4ZM12 8C13.1046 8 14 8.89543 14 10C14 11.1046 13.1046 12 12 12C10.8954 12 10 11.1046 10 10C10 8.89543 10.8954 8 12 8Z"
      fill="white"
    />
  </svg>
))``;
